import gql from 'graphql-tag'
import {
  seoFragment,
  blockFragment,
  blockExtendedFragment,
  brandsFragment
} from './fragments'

// fragments
const influencerFragment = gql`
  fragment Influencer on Influencer {
    slug
    name
    designation
    description
    theme
    speakerType
    bio
    instagramLink
    linkedinLink
    twitterLink
    themeColor
    image {
      data {
        attributes {
          url
          width
          height
          alternativeText
        }
      }
    }
    profileImage {
      data {
        attributes {
          url
          width
          height
          alternativeText
        }
      }
    }
  }
`

// TODO: there is not distinction between featured and trending influencer on strapi
export const influencerPageQuery = gql`
  {
    influencerPage {
      data {
        id
        attributes {
          brands {
            ...Brands
          }
          heroTitleImage {
            data {
              attributes {
                url
                width
                height
                alternativeText
              }
            }
          }
          heroImage {
            data {
              attributes {
                url
                width
                height
                alternativeText
              }
            }
          }
          heroDescription
          heroSubtext
          heroPrimaryCta {
            id
            title
            href
            target
          }
          heroSecondaryCta {
            id
            title
            href
            target
          }
          influencerTitle
          interviewInfluencers(pagination: { pageSize: 20 }) {
            data {
              attributes {
                ...Influencer
              }
            }
          }
          profileInfluencers(pagination: { pageSize: 20 }) {
            data {
              attributes {
                ...Influencer
              }
            }
          }
          featuredInfluencers(pagination: { pageSize: 16 }) {
            data {
              attributes {
                ...Influencer
              }
            }
          }
          contentTitle
          contentCtaTitle
          contentCtaLink
          contentUSP {
            Item
          }
          Seo {
            ...SEO
          }
          getStarted {
            ...BlockFragment
          }
          footerCta {
            ...BlockExtendedFragment
          }
          cmpTestimonialTitle
          cmpTestimonialList(pagination: { pageSize: 50 }) {
            authorName
            authorDesignation
            authorCompanyImage {
              data {
                attributes {
                  url
                  alternativeText
                  width
                  height
                }
              }
            }
            authorImage {
              data {
                attributes {
                  url
                  alternativeText
                  width
                  height
                }
              }
            }
            review
          }
        }
      }
    }
  }
  ${seoFragment}
  ${brandsFragment}
  ${influencerFragment}
  ${blockFragment}
  ${blockExtendedFragment}
`

export const influencerDetailsPageQuery = gql`
  query individualInfluencer($slug: String!) {
    influencers(filters: { slug: { eq: $slug } }) {
      data {
        id
        attributes {
          Seo {
            ...SEO
          }
          name
          slug
          designation
          description
          instagramLink
          linkedinLink
          twitterLink
          bio
          themeColor
          image {
            data {
              attributes {
                url
                width
                height
                alternativeText
              }
            }
          }
        }
      }
    }
    influencerPage {
      data {
        attributes {
          getStarted {
            ...BlockFragment
          }
        }
      }
    }
  }
  ${seoFragment}
  ${blockFragment}
`

export const speakerPageQuery = gql`
  query ($page: Int, $theme: String) {
    influencers(
      pagination: { pageSize: 6, page: $page }
      filters: { theme: { eq: $theme } }
    ) {
      meta {
        pagination {
          total
          page
          pageSize
          pageCount
        }
      }
      data {
        attributes {
          ...Influencer
        }
      }
    }
  }
  ${influencerFragment}
`

export const filteredLeadersPageQuery = gql`
  query ($page: Int, $speakerType: String!, $theme: String) {
    influencers(
      pagination: { pageSize: 6, page: $page }
      filters: { speakerType: { eq: $speakerType }, theme: { eq: $theme } }
    ) {
      meta {
        pagination {
          total
          page
          pageSize
          pageCount
        }
      }
      data {
        attributes {
          ...Influencer
        }
      }
    }
  }
  ${influencerFragment}
`

export const allLeadersPageQuery = gql`
  query ($page: Int, $speakerType: [String!], $theme: String) {
    influencers(
      pagination: { pageSize: 16, page: $page }
      filters: { speakerType: { in: $speakerType }, theme: { eq: $theme } }
    ) {
      meta {
        pagination {
          total
          page
          pageSize
          pageCount
        }
      }
      data {
        attributes {
          ...Influencer
        }
      }
    }
  }
  ${influencerFragment}
`
